/* eslint-disable angular/file-name */
angular.module('zc.zenclerkS')
  .directive('zcsCampaignTemplateItem', zcsCampaignTemplateItem)
  .controller('zcsCampaignTemplateItemController', zcsCampaignTemplateItemController);

zcsCampaignTemplateItem.$inject = ['Meta'];
function zcsCampaignTemplateItem(Meta) {
  return {
    restrict: 'E',
    scope: {
      campaign: '=',
      item: '='
    },
    templateUrl: '/templates/zenclerk_s/directives/campaign/template_editor/campaign_template_item.html',
    link(scope) {
      Meta.getServices()
        .then(services => {
          scope.adminApp = services.server;
        });

      // giftcard pattern handler
      scope.setPattern = function(pattern) {
        scope.campaign.userPattern = false;
        scope.campaign.element.message.show_incentive_text = true;
        scope.campaign.element.message.coupon_pattern = pattern;
      };
    },
    controllerAs: 'vm',
    controller: 'zcsCampaignTemplateItemController'
  };
}

zcsCampaignTemplateItemController.$inject = ['$translate'];
function zcsCampaignTemplateItemController($translate) {
  const vm = this;

  vm.$onInit = () => {
    vm.viewShow = false;

    vm.isUploadV5InstructionVisible = false;
    vm.uploadV5Instruction = `
      <div class="row">
        <div class="col-sm-4"><strong>${$translate.instant('directives.campaign.templateEditor.instructions.upload.imageSize')}</strong></div>
        <div class="col-sm-8">${$translate.instant('directives.campaign.templateEditor.instructions.upload.imageSizeDetails', { horizontal: '560px', vertical: '560px' })}</div>
      </div>
      <div class="row">
        <div class="col-sm-4"><strong>${$translate.instant('directives.campaign.templateEditor.instructions.upload.imageFormat')}</strong></div>
        <div class="col-sm-8">${$translate.instant('directives.campaign.templateEditor.instructions.upload.imageFormatDetails')}</div>
      </div>
      <div class="row">
        <div class="col-sm-4"><strong>${$translate.instant('directives.campaign.templateEditor.instructions.upload.capacity')}</strong></div>
        <div class="col-sm-8">png, jpg</div>
      </div>
      <p>${$translate.instant('directives.campaign.templateEditor.instructions.upload.displayDetails')}</p>
      <img src="/assets/img/editor/coupon-image-example1.png" />
      <img src="/assets/img/editor/coupon-image-example2.png" />
    `;

    vm.isUploadGiftcardInstructionVisible = false;
    vm.uploadGiftCardInstruction = `
      <div class="row">
        <div class="col-sm-4"><strong>${$translate.instant('directives.campaign.templateEditor.instructions.upload.imageSize')}</strong></div>
        <div class="col-sm-8">${$translate.instant('directives.campaign.templateEditor.instructions.upload.imageSizeDetails', { horizontal: '600px', vertical: '330px' })}</div>
      </div>
      <div class="row">
        <div class="col-sm-4"><strong>${$translate.instant('directives.campaign.templateEditor.instructions.upload.imageFormat')}</strong></div>
        <div class="col-sm-8">${$translate.instant('directives.campaign.templateEditor.instructions.upload.imageFormatDetails')}</div>
      </div>
      <div class="row">
        <div class="col-sm-4"><strong>${$translate.instant('directives.campaign.templateEditor.instructions.upload.capacity')}</strong></div>
        <div class="col-sm-8">png, jpg</div>
      </div>
      <p>${$translate.instant('directives.campaign.templateEditor.instructions.upload.displayDetails')}</p>
    `;
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/campaign/template_editor/campaign_template_item.directive.js